package com.eladfinish.bible.contest

import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.`internal`.SupportedLocale
import dev.icerock.moko.resources.`internal`.SupportedLocales
import dev.icerock.moko.resources.provider.RemoteJsStringLoader
import kotlin.String
import kotlin.collections.List

private val fallbackFileUrl: String =
    js("require(\"./localization/comeladfinishbiblecontest_stringsJson.json\")") as String

private val supportedLocales: SupportedLocales = SupportedLocales(listOf(
    SupportedLocale("de",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_de.json\")") as String),
    SupportedLocale("en",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_en.json\")") as String),
    SupportedLocale("es",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_es.json\")") as String),
    SupportedLocale("fr",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_fr.json\")") as String),
    SupportedLocale("ru",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_ru.json\")") as String),
    ))

private val stringsLoader: RemoteJsStringLoader = RemoteJsStringLoader.Impl(supportedLocales =
    supportedLocales, fallbackFileUri = fallbackFileUrl)

internal object CommonMainStrings7 {
  internal val perek_str_double_placeholder: StringResource by lazy {
      init_perek_str_double_placeholder() }

  internal val perek_str_hebrew: StringResource by lazy { init_perek_str_hebrew() }

  internal val perek_str_placeholder: StringResource by lazy { init_perek_str_placeholder() }

  internal val permission_denied_by_user: StringResource by lazy { init_permission_denied_by_user()
      }

  internal val personal_list: StringResource by lazy { init_personal_list() }

  internal val personal_list_hint: StringResource by lazy { init_personal_list_hint() }

  internal val pick_book: StringResource by lazy { init_pick_book() }

  internal val pick_chapter: StringResource by lazy { init_pick_chapter() }

  internal val pirkei: StringResource by lazy { init_pirkei() }

  internal val pirkei_format: StringResource by lazy { init_pirkei_format() }

  internal val pref_description_alphabetical: StringResource by lazy {
      init_pref_description_alphabetical() }

  internal val pref_description_alphabetical_disabled: StringResource by lazy {
      init_pref_description_alphabetical_disabled() }

  internal val pref_description_anonymous_usage_stats: StringResource by lazy {
      init_pref_description_anonymous_usage_stats() }

  internal val pref_description_hide_people_names: StringResource by lazy {
      init_pref_description_hide_people_names() }

  internal val pref_description_hide_people_names_disabled: StringResource by lazy {
      init_pref_description_hide_people_names_disabled() }

  internal val pref_description_hide_title_bar_on_scroll: StringResource by lazy {
      init_pref_description_hide_title_bar_on_scroll() }

  internal val pref_description_hide_title_bar_on_scroll_disabled: StringResource by lazy {
      init_pref_description_hide_title_bar_on_scroll_disabled() }

  internal val pref_description_mikud: StringResource by lazy { init_pref_description_mikud() }

  internal val pref_description_mikud_off: StringResource by lazy {
      init_pref_description_mikud_off() }

  internal val pref_description_new_line: StringResource by lazy { init_pref_description_new_line()
      }

  internal val pref_description_night_mode: StringResource by lazy {
      init_pref_description_night_mode() }

  internal val pref_description_nikud: StringResource by lazy { init_pref_description_nikud() }

  internal val pref_description_nikud_disabled: StringResource by lazy {
      init_pref_description_nikud_disabled() }

  internal val pref_description_open_questions_number_per_page: StringResource by lazy {
      init_pref_description_open_questions_number_per_page() }

  internal val pref_description_qri: StringResource by lazy { init_pref_description_qri() }

  internal val pref_description_qri_disabled: StringResource by lazy {
      init_pref_description_qri_disabled() }

  internal val pref_description_shake: StringResource by lazy { init_pref_description_shake() }

  internal val pref_description_show_full_chapter: StringResource by lazy {
      init_pref_description_show_full_chapter() }

  internal val pref_description_sounds: StringResource by lazy { init_pref_description_sounds() }

  internal val pref_description_sounds_disabled: StringResource by lazy {
      init_pref_description_sounds_disabled() }

  internal val pref_description_teamim: StringResource by lazy { init_pref_description_teamim() }

  internal val pref_description_teamim_disabled: StringResource by lazy {
      init_pref_description_teamim_disabled() }

  internal val pref_description_vibrations: StringResource by lazy {
      init_pref_description_vibrations() }

  internal val pref_description_vibrations_disabled: StringResource by lazy {
      init_pref_description_vibrations_disabled() }

  internal val pref_font_size_title: StringResource by lazy { init_pref_font_size_title() }

  internal val pref_font_title: StringResource by lazy { init_pref_font_title() }

  internal val pref_font_type_title: StringResource by lazy { init_pref_font_type_title() }

  internal val pref_header_notifications: StringResource by lazy { init_pref_header_notifications()
      }

  internal val pref_hebrew_gender_language_male: StringResource by lazy {
      init_pref_hebrew_gender_language_male() }

  internal val pref_hebrew_gender_language_title: StringResource by lazy {
      init_pref_hebrew_gender_language_title() }

  internal val pref_language_title: StringResource by lazy { init_pref_language_title() }

  internal val pref_size_title: StringResource by lazy { init_pref_size_title() }

  internal val preferences_have_been_reset: StringResource by lazy {
      init_preferences_have_been_reset() }

  internal val preferences_saved: StringResource by lazy { init_preferences_saved() }

  internal val preset_completions: StringResource by lazy { init_preset_completions() }

  internal val preset_mikud: StringResource by lazy { init_preset_mikud() }

  internal val preview: StringResource by lazy { init_preview() }

  internal val previous_question: StringResource by lazy { init_previous_question() }

  internal val prize: StringResource by lazy { init_prize() }

  internal val purchase: StringResource by lazy { init_purchase() }

  internal fun values(): List<StringResource> = listOf(perek_str_double_placeholder,
      perek_str_hebrew, perek_str_placeholder, permission_denied_by_user, personal_list,
      personal_list_hint, pick_book, pick_chapter, pirkei, pirkei_format,
      pref_description_alphabetical, pref_description_alphabetical_disabled,
      pref_description_anonymous_usage_stats, pref_description_hide_people_names,
      pref_description_hide_people_names_disabled, pref_description_hide_title_bar_on_scroll,
      pref_description_hide_title_bar_on_scroll_disabled, pref_description_mikud,
      pref_description_mikud_off, pref_description_new_line, pref_description_night_mode,
      pref_description_nikud, pref_description_nikud_disabled,
      pref_description_open_questions_number_per_page, pref_description_qri,
      pref_description_qri_disabled, pref_description_shake, pref_description_show_full_chapter,
      pref_description_sounds, pref_description_sounds_disabled, pref_description_teamim,
      pref_description_teamim_disabled, pref_description_vibrations,
      pref_description_vibrations_disabled, pref_font_size_title, pref_font_title,
      pref_font_type_title, pref_header_notifications, pref_hebrew_gender_language_male,
      pref_hebrew_gender_language_title, pref_language_title, pref_size_title,
      preferences_have_been_reset, preferences_saved, preset_completions, preset_mikud, preview,
      previous_question, prize, purchase)
}

private fun init_perek_str_double_placeholder(): StringResource = StringResource(key =
    "perek_str_double_placeholder", loader = stringsLoader)

private fun init_perek_str_hebrew(): StringResource = StringResource(key = "perek_str_hebrew",
    loader = stringsLoader)

private fun init_perek_str_placeholder(): StringResource = StringResource(key =
    "perek_str_placeholder", loader = stringsLoader)

private fun init_permission_denied_by_user(): StringResource = StringResource(key =
    "permission_denied_by_user", loader = stringsLoader)

private fun init_personal_list(): StringResource = StringResource(key = "personal_list", loader =
    stringsLoader)

private fun init_personal_list_hint(): StringResource = StringResource(key = "personal_list_hint",
    loader = stringsLoader)

private fun init_pick_book(): StringResource = StringResource(key = "pick_book", loader =
    stringsLoader)

private fun init_pick_chapter(): StringResource = StringResource(key = "pick_chapter", loader =
    stringsLoader)

private fun init_pirkei(): StringResource = StringResource(key = "pirkei", loader = stringsLoader)

private fun init_pirkei_format(): StringResource = StringResource(key = "pirkei_format", loader =
    stringsLoader)

private fun init_pref_description_alphabetical(): StringResource = StringResource(key =
    "pref_description_alphabetical", loader = stringsLoader)

private fun init_pref_description_alphabetical_disabled(): StringResource = StringResource(key =
    "pref_description_alphabetical_disabled", loader = stringsLoader)

private fun init_pref_description_anonymous_usage_stats(): StringResource = StringResource(key =
    "pref_description_anonymous_usage_stats", loader = stringsLoader)

private fun init_pref_description_hide_people_names(): StringResource = StringResource(key =
    "pref_description_hide_people_names", loader = stringsLoader)

private fun init_pref_description_hide_people_names_disabled(): StringResource = StringResource(key
    = "pref_description_hide_people_names_disabled", loader = stringsLoader)

private fun init_pref_description_hide_title_bar_on_scroll(): StringResource = StringResource(key =
    "pref_description_hide_title_bar_on_scroll", loader = stringsLoader)

private fun init_pref_description_hide_title_bar_on_scroll_disabled(): StringResource =
    StringResource(key = "pref_description_hide_title_bar_on_scroll_disabled", loader =
    stringsLoader)

private fun init_pref_description_mikud(): StringResource = StringResource(key =
    "pref_description_mikud", loader = stringsLoader)

private fun init_pref_description_mikud_off(): StringResource = StringResource(key =
    "pref_description_mikud_off", loader = stringsLoader)

private fun init_pref_description_new_line(): StringResource = StringResource(key =
    "pref_description_new_line", loader = stringsLoader)

private fun init_pref_description_night_mode(): StringResource = StringResource(key =
    "pref_description_night_mode", loader = stringsLoader)

private fun init_pref_description_nikud(): StringResource = StringResource(key =
    "pref_description_nikud", loader = stringsLoader)

private fun init_pref_description_nikud_disabled(): StringResource = StringResource(key =
    "pref_description_nikud_disabled", loader = stringsLoader)

private fun init_pref_description_open_questions_number_per_page(): StringResource =
    StringResource(key = "pref_description_open_questions_number_per_page", loader = stringsLoader)

private fun init_pref_description_qri(): StringResource = StringResource(key =
    "pref_description_qri", loader = stringsLoader)

private fun init_pref_description_qri_disabled(): StringResource = StringResource(key =
    "pref_description_qri_disabled", loader = stringsLoader)

private fun init_pref_description_shake(): StringResource = StringResource(key =
    "pref_description_shake", loader = stringsLoader)

private fun init_pref_description_show_full_chapter(): StringResource = StringResource(key =
    "pref_description_show_full_chapter", loader = stringsLoader)

private fun init_pref_description_sounds(): StringResource = StringResource(key =
    "pref_description_sounds", loader = stringsLoader)

private fun init_pref_description_sounds_disabled(): StringResource = StringResource(key =
    "pref_description_sounds_disabled", loader = stringsLoader)

private fun init_pref_description_teamim(): StringResource = StringResource(key =
    "pref_description_teamim", loader = stringsLoader)

private fun init_pref_description_teamim_disabled(): StringResource = StringResource(key =
    "pref_description_teamim_disabled", loader = stringsLoader)

private fun init_pref_description_vibrations(): StringResource = StringResource(key =
    "pref_description_vibrations", loader = stringsLoader)

private fun init_pref_description_vibrations_disabled(): StringResource = StringResource(key =
    "pref_description_vibrations_disabled", loader = stringsLoader)

private fun init_pref_font_size_title(): StringResource = StringResource(key =
    "pref_font_size_title", loader = stringsLoader)

private fun init_pref_font_title(): StringResource = StringResource(key = "pref_font_title", loader
    = stringsLoader)

private fun init_pref_font_type_title(): StringResource = StringResource(key =
    "pref_font_type_title", loader = stringsLoader)

private fun init_pref_header_notifications(): StringResource = StringResource(key =
    "pref_header_notifications", loader = stringsLoader)

private fun init_pref_hebrew_gender_language_male(): StringResource = StringResource(key =
    "pref_hebrew_gender_language_male", loader = stringsLoader)

private fun init_pref_hebrew_gender_language_title(): StringResource = StringResource(key =
    "pref_hebrew_gender_language_title", loader = stringsLoader)

private fun init_pref_language_title(): StringResource = StringResource(key = "pref_language_title",
    loader = stringsLoader)

private fun init_pref_size_title(): StringResource = StringResource(key = "pref_size_title", loader
    = stringsLoader)

private fun init_preferences_have_been_reset(): StringResource = StringResource(key =
    "preferences_have_been_reset", loader = stringsLoader)

private fun init_preferences_saved(): StringResource = StringResource(key = "preferences_saved",
    loader = stringsLoader)

private fun init_preset_completions(): StringResource = StringResource(key = "preset_completions",
    loader = stringsLoader)

private fun init_preset_mikud(): StringResource = StringResource(key = "preset_mikud", loader =
    stringsLoader)

private fun init_preview(): StringResource = StringResource(key = "preview", loader = stringsLoader)

private fun init_previous_question(): StringResource = StringResource(key = "previous_question",
    loader = stringsLoader)

private fun init_prize(): StringResource = StringResource(key = "prize", loader = stringsLoader)

private fun init_purchase(): StringResource = StringResource(key = "purchase", loader =
    stringsLoader)

public actual val SharedRes.strings.perek_str_double_placeholder: StringResource
  get() = CommonMainStrings7.perek_str_double_placeholder

public actual val SharedRes.strings.perek_str_hebrew: StringResource
  get() = CommonMainStrings7.perek_str_hebrew

public actual val SharedRes.strings.perek_str_placeholder: StringResource
  get() = CommonMainStrings7.perek_str_placeholder

public actual val SharedRes.strings.permission_denied_by_user: StringResource
  get() = CommonMainStrings7.permission_denied_by_user

public actual val SharedRes.strings.personal_list: StringResource
  get() = CommonMainStrings7.personal_list

public actual val SharedRes.strings.personal_list_hint: StringResource
  get() = CommonMainStrings7.personal_list_hint

public actual val SharedRes.strings.pick_book: StringResource
  get() = CommonMainStrings7.pick_book

public actual val SharedRes.strings.pick_chapter: StringResource
  get() = CommonMainStrings7.pick_chapter

public actual val SharedRes.strings.pirkei: StringResource
  get() = CommonMainStrings7.pirkei

public actual val SharedRes.strings.pirkei_format: StringResource
  get() = CommonMainStrings7.pirkei_format

public actual val SharedRes.strings.pref_description_alphabetical: StringResource
  get() = CommonMainStrings7.pref_description_alphabetical

public actual val SharedRes.strings.pref_description_alphabetical_disabled: StringResource
  get() = CommonMainStrings7.pref_description_alphabetical_disabled

public actual val SharedRes.strings.pref_description_anonymous_usage_stats: StringResource
  get() = CommonMainStrings7.pref_description_anonymous_usage_stats

public actual val SharedRes.strings.pref_description_hide_people_names: StringResource
  get() = CommonMainStrings7.pref_description_hide_people_names

public actual val SharedRes.strings.pref_description_hide_people_names_disabled: StringResource
  get() = CommonMainStrings7.pref_description_hide_people_names_disabled

public actual val SharedRes.strings.pref_description_hide_title_bar_on_scroll: StringResource
  get() = CommonMainStrings7.pref_description_hide_title_bar_on_scroll

public actual val SharedRes.strings.pref_description_hide_title_bar_on_scroll_disabled:
    StringResource
  get() = CommonMainStrings7.pref_description_hide_title_bar_on_scroll_disabled

public actual val SharedRes.strings.pref_description_mikud: StringResource
  get() = CommonMainStrings7.pref_description_mikud

public actual val SharedRes.strings.pref_description_mikud_off: StringResource
  get() = CommonMainStrings7.pref_description_mikud_off

public actual val SharedRes.strings.pref_description_new_line: StringResource
  get() = CommonMainStrings7.pref_description_new_line

public actual val SharedRes.strings.pref_description_night_mode: StringResource
  get() = CommonMainStrings7.pref_description_night_mode

public actual val SharedRes.strings.pref_description_nikud: StringResource
  get() = CommonMainStrings7.pref_description_nikud

public actual val SharedRes.strings.pref_description_nikud_disabled: StringResource
  get() = CommonMainStrings7.pref_description_nikud_disabled

public actual val SharedRes.strings.pref_description_open_questions_number_per_page: StringResource
  get() = CommonMainStrings7.pref_description_open_questions_number_per_page

public actual val SharedRes.strings.pref_description_qri: StringResource
  get() = CommonMainStrings7.pref_description_qri

public actual val SharedRes.strings.pref_description_qri_disabled: StringResource
  get() = CommonMainStrings7.pref_description_qri_disabled

public actual val SharedRes.strings.pref_description_shake: StringResource
  get() = CommonMainStrings7.pref_description_shake

public actual val SharedRes.strings.pref_description_show_full_chapter: StringResource
  get() = CommonMainStrings7.pref_description_show_full_chapter

public actual val SharedRes.strings.pref_description_sounds: StringResource
  get() = CommonMainStrings7.pref_description_sounds

public actual val SharedRes.strings.pref_description_sounds_disabled: StringResource
  get() = CommonMainStrings7.pref_description_sounds_disabled

public actual val SharedRes.strings.pref_description_teamim: StringResource
  get() = CommonMainStrings7.pref_description_teamim

public actual val SharedRes.strings.pref_description_teamim_disabled: StringResource
  get() = CommonMainStrings7.pref_description_teamim_disabled

public actual val SharedRes.strings.pref_description_vibrations: StringResource
  get() = CommonMainStrings7.pref_description_vibrations

public actual val SharedRes.strings.pref_description_vibrations_disabled: StringResource
  get() = CommonMainStrings7.pref_description_vibrations_disabled

public actual val SharedRes.strings.pref_font_size_title: StringResource
  get() = CommonMainStrings7.pref_font_size_title

public actual val SharedRes.strings.pref_font_title: StringResource
  get() = CommonMainStrings7.pref_font_title

public actual val SharedRes.strings.pref_font_type_title: StringResource
  get() = CommonMainStrings7.pref_font_type_title

public actual val SharedRes.strings.pref_header_notifications: StringResource
  get() = CommonMainStrings7.pref_header_notifications

public actual val SharedRes.strings.pref_hebrew_gender_language_male: StringResource
  get() = CommonMainStrings7.pref_hebrew_gender_language_male

public actual val SharedRes.strings.pref_hebrew_gender_language_title: StringResource
  get() = CommonMainStrings7.pref_hebrew_gender_language_title

public actual val SharedRes.strings.pref_language_title: StringResource
  get() = CommonMainStrings7.pref_language_title

public actual val SharedRes.strings.pref_size_title: StringResource
  get() = CommonMainStrings7.pref_size_title

public actual val SharedRes.strings.preferences_have_been_reset: StringResource
  get() = CommonMainStrings7.preferences_have_been_reset

public actual val SharedRes.strings.preferences_saved: StringResource
  get() = CommonMainStrings7.preferences_saved

public actual val SharedRes.strings.preset_completions: StringResource
  get() = CommonMainStrings7.preset_completions

public actual val SharedRes.strings.preset_mikud: StringResource
  get() = CommonMainStrings7.preset_mikud

public actual val SharedRes.strings.preview: StringResource
  get() = CommonMainStrings7.preview

public actual val SharedRes.strings.previous_question: StringResource
  get() = CommonMainStrings7.previous_question

public actual val SharedRes.strings.prize: StringResource
  get() = CommonMainStrings7.prize

public actual val SharedRes.strings.purchase: StringResource
  get() = CommonMainStrings7.purchase
